export const ROLE_HIERARCHY = {
    user: 0,
    staff: 1,
    admin: 2,
    super_admin: 3,
};
export function hasMinimumRole(userRole, requiredRole) {
    return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}
//# sourceMappingURL=roles.js.map